// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Bot as RawBot } from "lucide-react";
export const Bot = /* @__PURE__ */ createIcon(RawBot, "Bot", 2);
